import { render, staticRenderFns } from "./TemplateParameters.vue?vue&type=template&id=6dfc6204"
import script from "./TemplateParameters.vue?vue&type=script&lang=js"
export * from "./TemplateParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports